import { StyleProp, StyleSheet, TextStyle, View, ViewStyle } from 'react-native'

import { useStore } from '../../../models'
import { events } from '../../../models/analytics/analytics-events'
import { color, fontFamily } from '../../../theme'
import { ButtonEmoji } from '../ButtonEmoji'
import { DS } from '../../../design-system'
import { useCommonCommands } from '../../../screens/new-design/hooks/useCommonCommands'

const EMOJIS = ['👑', '👏', '🙌', '🔥', '💃🏻']

type WinnerCelebrationProps = {
  customWinnerTextStyle?: StyleProp<TextStyle>
  customCelebrationContainer?: StyleProp<ViewStyle>
  isGameOverScreen?: boolean
}

export const WinnerCelebration = ({
  customWinnerTextStyle,
  customCelebrationContainer,
  isGameOverScreen
}: WinnerCelebrationProps) => {
  const onSendCelebration = useCommonCommands('onSendCelebration', { isGameOverScreen })
  // TODO REMOVE
  // const {
  //   game: { gameId },
  //   communication: { sendCelebration },
  //   analytics: { setEvent }
  // } = useStore()

  // const onSendCelebration = (emoji: string) => {
  //   setEvent(isGameOverScreen ? events.gameOverScreen.game_celebrated : events.gameOverScreen.hand_celebrated, {
  //     game_id: gameId,
  //     emoji_type: emoji
  //   })
  //   sendCelebration(emoji)
  // }

  return (
    <View style={[styles.container, customCelebrationContainer]}>
      <DS.Text variant="Caption/Bold" style={[styles.celebrateWinText, customWinnerTextStyle]}>
        CELEBRATE THE WIN!
      </DS.Text>
      <View style={[styles.celebrationContainer]}>
        {EMOJIS.map((e, idx) => (
          <ButtonEmoji key={`winner-emoji-${idx}`} emoji={e} onPress={onSendCelebration} />
        ))}
      </View>
    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    paddingTop: 24,
    borderTopWidth: 1,
    borderColor: color.palette.timberwolf
  },
  celebrationContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    gap: 8
  },
  celebrateWinText: {
    fontFamily: fontFamily.GTAmericaExtended,
    fontSize: 12,
    color: color.palette.smokyBlack,
    textAlign: 'center',
    marginBottom: 16
  }
})
